var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuySubscription = function SvgBuySubscription(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D29214",
    fillRule: "evenodd",
    d: "M9.219 17.669a3.42 3.42 0 0 0 2.563-.001l1.787-.733a1.1 1.1 0 0 1 .867.024l.631.306a1.41 1.41 0 0 0 1.37-.08c.415-.262.663-.712.662-1.204l-.008-10.216c0-2.272-1.363-3.683-3.555-3.683H7.453c-2.214 0-3.536 1.377-3.536 3.682L3.902 15.98c0 .493.25.943.668 1.204.415.26.927.285 1.364.073l.624-.297c.28-.128.596-.137.87-.026zm3.252-5.004H8.214a.625.625 0 0 1 0-1.25h4.257a.625.625 0 0 1 0 1.25M9.399 9.923a.62.62 0 0 0 .883 0l2.631-2.633a.626.626 0 0 0-.884-.883l-2.19 2.19-.842-.84a.624.624 0 1 0-.883.883z",
    clipRule: "evenodd"
  })));
};
export default SvgBuySubscription;